import React, { useEffect, useContext } from "react";
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Divider,
  Avatar,
  IconButton,
  Box,
  Button,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode } from "@fortawesome/free-solid-svg-icons";
import CloseIcon from "@mui/icons-material/Close";
import dashRoutes from "../models/general/routes";
import ModalDetalles from "../shared/modals/ModalDetalles";
import { RootStoreContext } from "../app/store/root";
import { observer } from "mobx-react-lite";
import { account } from "../shared/Utils";
import { ModalComponent } from "../app/common/ModalComponent";
import { Menu } from '../app/util/permisos';
import { getFormatDate, getDayOfWeek } from '../app/util/util';

function MainPage() {
  const navigate = useNavigate();
  const rootStore = useContext(RootStoreContext);

  const {
    getById,
    getMovimientosToday: _getMovimientosToday,
    revisonMovimientoUsuario,
  } = rootStore.shipmentStore;

  const [movimientosToday, setMovimientosToday] = React.useState([]);
  const [todayFormat, setTodayFormat] = React.useState("");
  const [dayOfWeekFormat, setDayOfWeekFormat] = React.useState("");
  const [model, setModel] = React.useState(undefined);

  useEffect(() => {
    document.title='Lilofy | Dashboard';
    if (
      !account
        .getPermisosUsuario()
        .some((a) => a.clavePermiso == Menu.Dashboard && a.tienePermiso)
    ) {
      navigate("/Usuarios/AccessDenied");
    } else {
      loadDataPage();
    }
  }, []);

    const loadDataPage = () => {
        getMovimientosToday()
        setTodayFormat(getFormatDate(new Date(), 'dd/MM/yyyy'))
        setDayOfWeekFormat(getDayOfWeek(new Date()))
    }

  const getMovimientosToday = async () => {
    let data = await _getMovimientosToday();
    if (data?.success) {
      setMovimientosToday(data.data);
    }
  };

  const cerrarTodas = async () => {
    let idMovimientos = movimientosToday.map((a) => {
      return a.idMovimientoGuia;
    });
    let resp = await revisonMovimientoUsuario(idMovimientos);
    if (resp?.success) {
      getMovimientosToday();
    }
  };

  const cerrarMovimiento = async (idMovimientoGuia) => {
    let idMovimientos = [idMovimientoGuia];
    let resp = await revisonMovimientoUsuario(idMovimientos);
    if (resp?.success) {
      getMovimientosToday();
    }
  };

    const getOptions = (dashRoutes) => {
        let permisosUsuario = account.getPermisosUsuario()
        let optionsUsers = dashRoutes.filter(a => permisosUsuario.filter(a => a.esMenu && a.tienePermiso).map(a => { return a.clavePermiso }).includes(a.clave))
        return optionsUsers.map((prop, key) => {
            return (
                <Link to={prop.layout + prop.path} key={key} className="linksTo">
                    <Box width={'150px'} height={'100px'}>
                        <Card className='card card-button' sx={{ height: '100%' }}>
                            <CardContent className='card-body text-center'>
                                <Grid container direction={'column'} justifyContent="center" alignItems="center">
                                    <Box color="primary.main" sx={{ fontSize: 26 }}>
                                        {prop.icon}
                                    </Box>
                                    <Typography >{prop.name}</Typography>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Box>
                </Link>

            );
        });
    }

  var createOptions = getOptions(dashRoutes);

  //DIALOG DETALLE
  const [openDetalle, setOpenDialogDetalle] = React.useState(null);

  const openDialogDetalle = async (data) => {
    rootStore.logisticBackdropStore.openLoading();
    await getById(data?.idGuia)
    setModel(data);
    setOpenDialogDetalle(true);
    rootStore.logisticBackdropStore.closeLoading();
  };

  const closeDialogDetalle = (event, reason) => {
    if (reason && reason == "backdropClick") 
        return;
    setOpenDialogDetalle(null);
  };

    return (
        <>
            <div className="main-container" >
                {/* <div className='mb-2 d-flex' style={{alignItems: 'center'}}>
                    <Box sx={{marginRight: '16px', fontSize: 25}} color="primary.main">
                        <FontAwesomeIcon icon={faEllipsisV} />
                    </Box>
                    <Typography color='primary' variant='h4'>
                        Opciones
                    </Typography>
                </div> */}
        <Grid
          container
          gap={6}
          justifyContent="center"
          alignItems={"center"}
          mb={3}
          mt={2}
        >
          {createOptions}
        </Grid>

        <div className="mb-2 d-flex" style={{ alignItems: "center" }}>
          <Box sx={{ marginRight: "16px", fontSize: 25 }} color="primary.main">
            <FontAwesomeIcon icon={faBarcode} />
          </Box>
          <Typography color="primary" variant="h4">
            Guías programadas para hoy {dayOfWeekFormat} {todayFormat}
          </Typography>
          <Typography color="primary" variant="h4" align="right">
            <Button
              type="button"
              variant="contained"
              disabled={movimientosToday.length == 0}
              style={{ marginLeft: 10 }}
              onClick={cerrarTodas}
            >
              Cerrar todas
            </Button>            
          </Typography>
        </div>
        <Grid container spacing={2}>
          {movimientosToday.map((movimiento) => {
            return (
              <Grid item xs={12}>
                <Card sx={{ minHeight: "125px" }} className="card card-button">
                  <CardContent className="card-body" variant="smallCard">
                    <Grid container direction={"column"}>
                      <Grid
                        item
                        xs={"auto"}
                        display={"flex"}
                        justifyContent={"end"}
                      >
                        <IconButton
                          variant="closeIcon"
                          onClick={(e) => {
                            e.preventDefault();
                            cerrarMovimiento(movimiento.idMovimientoGuia);
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Grid>
                      <Grid
                        item
                        onClick={(e) => {
                          e.preventDefault();
                          openDialogDetalle(movimiento);
                        }}
                      >
                        <Grid container direction={"row"} spacing={2}>
                          <Grid
                            sm={2}
                            item
                            direction={"column"}
                            alignItems="center"
                            display={"flex"}
                          >
                            <Avatar
                              sx={{
                                width: 50,
                                height: 50,
                                bgcolor: "primary.main",
                              }}
                              variant="rounded"
                            >
                              <FontAwesomeIcon icon={faBarcode} />
                            </Avatar>
                            <Typography variant="subtitle" mt={1}>
                              {getFormatDate(movimiento.fechaEstimadaLlegadaGuia)}
                            </Typography>
                          </Grid>
                          <Grid
                            sm={3}
                            item
                            direction={"column"}
                            alignItems="center"
                            display={"flex"}
                          >
                            <Typography variant="h6">No. de guía</Typography>
                            <Typography variant="subtitle" mt={2}>
                              #{movimiento.numeroGuia}
                            </Typography>
                          </Grid>

                          <Grid item xs="auto" p={0}>
                            <Divider orientation="vertical" flexItem />
                          </Grid>

                          <Grid sm={4} item direction={"column"}>
                            <Typography variant="h6">
                              Empresa: {movimiento.proveedor}
                            </Typography>
                            <Typography variant="subtitle">
                              Fecha de creación:{" "}
                              {getFormatDate(movimiento.fechaCreoGuia)}
                            </Typography>
                          </Grid>

                          <Grid sm={2} item direction={"column"}>
                            <Typography variant="h6">Detalles</Typography>
                            <Typography variant="subtitle">
                              {movimiento.descripcionEnvio}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </div>
      <ModalComponent
        Open={openDetalle}
        HandleClose={closeDialogDetalle}
        ClassName="modal-xl"
        Body={() => <ModalDetalles onClose={closeDialogDetalle} />}
      />
    </>
  );
}

export default observer(MainPage);
